
export const SAVE_I140FORMS_STARTED = "SAVE_I140FORMS_STARTED";
export const SAVE_I140FORMS_SUCCESS = "SAVE_I140FORMS_SUCCESS";
export const SAVE_I140FORMS_FAILED = "SAVE_I140FORMS_FAILED"; 

export const UPDATE_I140FORMS_STARTED = "UPDATE_I140FORMS_STARTED";
export const UPDATE_I140FORMS_SUCCESS = "UPDATE_I140FORMS_SUCCESS";
export const UPDATE_I140FORMS_FAILED = "UPDATE_I140FORMS_FAILED";

export const GET_I140FORMS_STARTED = "GET_I140FORMS_STARTED";
export const GET_I140FORMS_SUCCESS = "GET_I140FORMS_SUCCESS";
export const GET_I140FORMS_FAILED = "GET_I140FORMS_FAILED";

export const SAVEPDF_I140FORMS_STARTED = "SAVEPDF_I140FORMS_STARTED";
export const SAVEPDF_I140FORMS_SUCCESS = "SAVEPDF_I140FORMS_SUCCESS";
export const SAVEPDF_I140FORMS_FAILED = "SAVEPDF_I140FORMS_FAILED";



export const i140formsCreate = (i140formsCreateInput: any) => {
 
    return {
        type: SAVE_I140FORMS_STARTED,
        payload: 'status',
        input: i140formsCreateInput
    };
};

export const i140formsUpdate = (i140formsUpdateInput: any) => {

   return {
       type: UPDATE_I140FORMS_STARTED,
       payload: 'status',
       input: i140formsUpdateInput
   };

};
export const getI140formsDetails = (i140formsUpdateInput: any) => {
   
    return {
        type: GET_I140FORMS_STARTED ,
        payload: 'Value',
        input:i140formsUpdateInput
    };
};

export const i140FormPdfSubmit = (pdfInput) => {
 
    return {
        type: SAVEPDF_I140FORMS_STARTED,
        payload: 'Value',
        input:pdfInput
    };
};
